import { render, staticRenderFns } from "./viewtable.vue?vue&type=template&id=36363616"
import script from "./viewtable.vue?vue&type=script&lang=js"
export * from "./viewtable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports